import React from "react";
import { HiOutlineMail } from "react-icons/hi";
import { RiLockPasswordLine } from "react-icons/ri";

export default function LoginForm({
  email,
  setEmail,
  pwd,
  setPwd,
  onSubmit,
  onForgot,
  isLoading,
  blockMessage,
}) {
  return (
    <form className="space-y-6 w-full" onSubmit={onSubmit}>
      {/* Erisim engeli — yetki kaynakli kalici hata (uretim ekibi hesabi,
          yetkisiz sablon). Toast kisa surdugu icin burada kalici gosterilir;
          kullanici yoneticisine ne soyleyecegini bilsin. */}
      {blockMessage && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3">
          <p className="text-sm text-red-700 leading-relaxed">{blockMessage}</p>
        </div>
      )}
      <div className="space-y-2">
        <label className="block text-slate-600 text-sm font-medium">
          Email
        </label>
        <div className="relative">
          <HiOutlineMail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-5 w-5" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-white border border-slate-200 rounded-lg py-3 pl-12 pr-4 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-base transition-all"
            placeholder="mail@example.com"
            disabled={isLoading}
          />
        </div>
      </div>
      <div className="space-y-2">
        <label className="block text-slate-600 text-sm font-medium">
          Şifre
        </label>
        <div className="relative">
          <RiLockPasswordLine className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-5 w-5" />
          <input
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            required
            className="w-full bg-white border border-slate-200 rounded-lg py-3 pl-12 pr-4 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-base transition-all"
            placeholder="••••••••"
            disabled={isLoading}
          />
        </div>
      </div>
      <div className="space-y-4">
        <button
          type="submit"
          className="w-full py-3 px-4 rounded-lg bg-indigo-600 text-white font-semibold shadow-sm hover:bg-indigo-700 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          disabled={isLoading}
        >
          {isLoading ? "Giriş Yapılıyor..." : "Giriş Yap"}
        </button>
        <button
          type="button"
          onClick={onForgot}
          className="w-full text-sm text-indigo-600 hover:text-indigo-700 transition-colors"
          disabled={isLoading}
        >
          Şifremi Unuttum
        </button>
      </div>
    </form>
  );
}
